export default __webpack_public_path__ + "static/media/Increased.abbb36f7.svg";